import { render } from "./BannerSection.vue?vue&type=template&id=5247755e"
import script from "./BannerSection.vue?vue&type=script&lang=js"
export * from "./BannerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__